import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BillModel } from '@data-layer/models/payments';
import { Location } from '@angular/common';

@Component({
  selector: 'payment-button',
  templateUrl: './payment-button-shared.component.html',
  styleUrls: ['./payment-button-shared.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentButtonSharedComponent {
  @Input() public referenceNumber: string;
  @Input() public bill: BillModel;
  @Input() public buttonText: string = 'GO_TO_PAYMENT';
  @Input() public returnUrl: string;
  @Input() public isHandleParent: boolean;
  @Input() public isDisabled: boolean;
  @Output() public validate: EventEmitter<void> = new EventEmitter<void>();

  constructor(private router: Router, private location: Location) {}

  public goToPayment(): void {
    if (this.isHandleParent) {
      this.validate.emit();
    } else {
      this.navigateAndPay();
    }
  }

  private navigateAndPay(): void {
    this.router.navigate(['payment'], {
      queryParams: { referenceNumbers: [this.referenceNumber], returnUrl: this.returnUrl || this.location.path() || '/' },
    });
  }
}
